<template>
  <div class="relative">
    <!-- Image -->
    <div class="row c-justify-center">
      <div class="col-12 text">
        <RemoteResponsiveImage
          :product-image-data="getParams.image"
          img-class="embed-responsive embed-responsive-item"
          sizes="100vw"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import SwiperCore from 'swiper'
import { EffectFade } from 'swiper/modules';

import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import { useModalStore } from '@/stores/ModalStore'

SwiperCore.use([EffectFade])

const modalStore = useModalStore()
const { getParams } = storeToRefs(modalStore)
</script>
